export default {
  createUnitClass: '新增单位类别',
  viewUnitClass: '查看单位类别',
  editUnitClass: '编辑单位类别',
  createUnit: '新增单位',
  editUnit: '编辑单位',
  viewUnit: '查看单位',
  unitClassCode: '单位类别代码',
  unitClassName: '单位类别名称',
  unitCode: '单位代码',
  unitName: '单位名称',
  unitSymbol: '单位符号',
  pleaseSelectUnitClass: '请先选择单位类别',
  whetherDeleteUnit: '是否确定要删除该单位',
  whetherDeleteUnitClass: '是否确定要删除该单位类别',
  unitCodeCanNotBeNull: '单位代码不能为空',
  unitNameCanNotBeNull: '单位名称不能为空',
  unitSymbolCanNotBeNull: '单位符号不能为空',
  unitClassCodeCanNotBeNull: '单位类别代码不能为空',
  unitClassNameCanNotBeNull: '单位类别名称不能为空',
}
